import { useContext } from 'react'

import {
  Box,
  Button,
  DoughnutChart,
  Icon,
  Text,
  ThemeColors,
  adjustColorBrightness,
  getThemeColor,
} from '@fairfashion/design-system'
import { useTheme } from 'styled-components'

import { ProviderContext } from '../../provider.context'

import * as Styles from './provider-risks-card.styles'
export const ProviderRisksCard = () => {
  const theme = useTheme()
  const { companyTraceabilityStatistics, actions } = useContext(ProviderContext)
  const hasRisk =
    companyTraceabilityStatistics &&
    companyTraceabilityStatistics?.socialEnvironmentalRiskQuantitySum.value > 0

  return (
    <Styles.Container
      borderRadius={theme.border_radius.table}
      boxShadow={theme.box_shadow.card}
      backgroundColor={theme.colors.custom.white}
      padding={3}
      gap={2}
      direction="column"
      flex={1}
      minWidth="290px"
    >
      <Box
        width="100%"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        gap={1}
      >
        <Box gap={1} alignItems="center">
          <Icon name="alert" color="grey_2" size={20} />
          <Text size="small" fontWeight={500} color="grey_2">
            Riscos Socioambientais
          </Text>
        </Box>
        <a href="#tabs">
          <Button
            variant="outlined"
            width="100%"
            fontSize="small"
            padding="8px"
            onClick={() => actions.setActiveTab('Riscos socioambientais')}
          >
            <Icon name="arrow_right_up" color="grey_2" size={16} />
          </Button>
        </a>
      </Box>
      <Box
        width="100%"
        justifyContent="space-between"
        alignItems="stretch"
        flexWrap="wrap"
        gap={3}
      >
        <Box
          alignItems="center"
          justifyContent="center"
          width="100%"
          gap={2}
          flexWrap="wrap"
        >
          <DoughnutChart
            size={120}
            parts={[
              {
                value:
                  companyTraceabilityStatistics
                    ?.socialEnvironmentalRiskQuantitySlavery.value ?? 0,
                color: `${adjustColorBrightness(getThemeColor('warning', theme), 0.15)}`,
              },
              {
                value:
                  companyTraceabilityStatistics
                    ?.socialEnvironmentalRiskQuantityEmbargo.value ?? 0,
                color: getThemeColor('warning', theme),
              },
              {
                value:
                  companyTraceabilityStatistics
                    ?.socialEnvironmentalRiskQuantityRegistrationStatus.value ??
                  0,
                color: adjustColorBrightness(
                  getThemeColor('warning', theme),
                  -0.15,
                ),
              },
            ]}
            totalValue={
              companyTraceabilityStatistics?.socialEnvironmentalRiskQuantitySum
                .value ?? 0
            }
          />
        </Box>
        <Box direction="column" gap={2}>
          {hasRisk ? (
            <>
              <Box alignItems="center" gap={1}>
                <Styles.LegendColor
                  backgroundColor={
                    `${adjustColorBrightness(getThemeColor('warning', theme), 0.15)}` as ThemeColors
                  }
                />
                <Text>
                  <strong>
                    {
                      companyTraceabilityStatistics
                        ?.socialEnvironmentalRiskQuantitySlavery.value
                    }
                  </strong>
                </Text>
                <Text>
                  {
                    companyTraceabilityStatistics
                      ?.socialEnvironmentalRiskQuantitySlavery.title
                  }
                </Text>
              </Box>
              <Box alignItems="center" gap={1}>
                <Styles.LegendColor
                  backgroundColor={getThemeColor('warning', theme)}
                />
                <Text>
                  <strong>
                    {companyTraceabilityStatistics
                      ?.socialEnvironmentalRiskQuantityEmbargo.value ?? 0}
                  </strong>
                </Text>
                <Text>
                  {
                    companyTraceabilityStatistics
                      ?.socialEnvironmentalRiskQuantityEmbargo.title
                  }
                </Text>
              </Box>
              <Box alignItems="center" gap={1}>
                <Styles.LegendColor
                  backgroundColor={
                    `${adjustColorBrightness(getThemeColor('warning', theme), -0.15)}` as ThemeColors
                  }
                />
                <Text>
                  <strong>
                    {companyTraceabilityStatistics
                      ?.socialEnvironmentalRiskQuantityRegistrationStatus
                      .value ?? 0}
                  </strong>
                </Text>
                <Text>
                  {
                    companyTraceabilityStatistics
                      ?.socialEnvironmentalRiskQuantityRegistrationStatus.title
                  }
                </Text>
              </Box>
            </>
          ) : (
            <Box alignItems="center" width="100%" gap={1}>
              <Icon name="shield_check" color="success" size={20} />
              <Text size="14px">Nenhum risco encontrado</Text>
            </Box>
          )}
        </Box>
      </Box>
      <Box flex={1} alignItems="flex-end" gap={1} width="100%">
        {companyTraceabilityStatistics?.lastSocialEnvironmentalRiskApiRequest && (
          <Text size="12px" color="grey_3">
            {`${
              companyTraceabilityStatistics
                ?.lastSocialEnvironmentalRiskApiRequest.title
            }: `}
          </Text>
        )}
        <Text size="12px" color="grey_3">
          {companyTraceabilityStatistics &&
            new Date(
              companyTraceabilityStatistics.lastSocialEnvironmentalRiskApiRequest.value,
            ).toLocaleDateString()}
        </Text>
      </Box>
    </Styles.Container>
  )
}
